import {
  handleSettingsAddLocations,
  handleSettingsLocationSelect,
  handleSettingsMachineSelect,
  handleSettingsSpecificLocationSelect,
} from '../../../components/store/slices/settings/force&CommandAndAdminSelectSlice';

export const selectLocationIndicatorDispatcherHandler = (
  dispatch,
  name,
  locationList,
  specificLocationList,
  machineList,
  newSelectedLocations
) => {
  dispatch(
    handleSettingsLocationSelect({
      switch: name,
      arr: locationList,
    })
  );
  if (specificLocationList.length > 0) {
    dispatch(
      handleSettingsSpecificLocationSelect({
        switch: name,
        arr: specificLocationList,
      })
    );
  }
  dispatch(
    handleSettingsMachineSelect({
      switch: name,
      arr: machineList,
    })
  );
  dispatch(
    handleSettingsAddLocations({
      switch: name,
      arr: newSelectedLocations,
    })
  );
};
